export enum FirestoreWriteOp {
  CreateGoal = 'create-goal',
  CreateLifeArea = 'create-life-area',
  CreatePushToken = 'create-push-token',
  CreateRelationships = 'create-relationships',
  CreateSmartList = 'create-smart-list',
  CreateSubTask = 'create-sub-task',
  CreateTag = 'create-tag',
  CreateTaskWithSubTasks = 'create-task-with-sub-tasks',
  CreateTasks = 'create-tasks',
  CreateVision = 'create-vision',
  DeleteExternalConnection = 'delete-external-connection',
  DeleteGoals = 'delete-goals',
  DeleteLifeArea = 'delete-life-area',
  DeletePushToken = 'delete-push-token',
  DeleteSmartList = 'delete-smart-list',
  DeleteTag = 'delete-tag',
  DeleteTask = 'delete-task',
  DeleteTasks = 'delete-tasks',
  DuplicateGoal = 'duplicate-goal',
  DuplicateTasks = 'duplicate-tasks',
  TransferSection = 'transfer-section',
  TransformGoalSectionToGoal = 'transform-goal-section-to-goal',
  TransformLifeAreaSectionToGoal = 'transform-life-area-section-to-goal',
  UpdateExternalConnection = 'update-external-connection',
  UpdateGoal = 'update-goal',
  UpdateLifeArea = 'update-life-area',
  UpdateLinkedGoal = 'update-linked-goal',
  UpdateLinkedLifeArea = 'update-linked-life-area',
  UpdateLinkedRelationships = 'update-linked-relationships',
  UpdateRelationshipReferences = 'update-relationship-references',
  UpdateSmartList = 'update-smart-list',
  UpdateTag = 'update-tag',
  UpdateTask = 'update-task',
  UpdateTasks = 'update-tasks',
  UpdateUser = 'update-user',
  UpdateUserSettings = 'update-user-settings',
  UpdateVision = 'update-vision',
}
